import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import $ from 'jquery';
import { Component }  from 'ml-component-web';

import './modal.css';

export default class ModalContainer extends Component {

	componentDidMount() {
		super.componentDidMount && super.componentDidMount();
		var p = document.getElementById('my-overlay');
		if (!p) {
			p = document.createElement('div');
			p.id = 'my-overlay';
			document.body.appendChild(p);
		}
		this.portal = p;
	}

	componentWillUnmount() {
		super.componentWillUnmount && super.componentWillUnmount();
		ReactDOM.unmountComponentAtNode(this.portal);
		document.body.removeChild(this.portal);
		$('body').removeClass('my-modal-open');
	}

	componentWillReceiveProps(newProps) {
		super.componentWillReceiveProps && super.componentWillReceiveProps();
		if (!this.props.children && newProps.children) {
			this.showModal();
		} else if (this.props.children && !newProps.children) {
			this.hideModal();
		}
		this.renderModalContent(newProps);
	}

	renderModalContent(props) {
		ReactDOM.unstable_renderSubtreeIntoContainer(
			this, (
				<ReactCSSTransitionGroup transitionName="my-modal" transitionAppear={true} transitionAppearTimeout={300} transitionEnterTimeout={500} transitionLeaveTimeout={300}>
					{props.children}
				</ReactCSSTransitionGroup>
			), 
			this.portal
		);
	}

	showModal() {
		this.portal.className = 'visible';
		//add a fake timeout to trigger the appear transition
		setTimeout(() => {
			this.portal.className= 'visible active';
		}, 0);

		var header = $("header.mylife-header");
		var content = $("main.mylife-content");
		//hold onto the current scroll position for when the modal is hidden
		this.contentScrollTop = content.scrollTop();

		//Make sure we don't apply the body style until after we've got the scroll position
		$('body').addClass('my-modal-open');
		content.css({
			top: header.height()-this.contentScrollTop
		});
	}

	hideModal() {
		$('body').removeClass('my-modal-open');
		
		this.portal.className = 'visible';
		setTimeout(() => {
			this.portal.className = '';
		}, 200)

		$("main.mylife-content").scrollTop(this.contentScrollTop);
	}

	render() {
		return null;
    }
}


/** WEBPACK FOOTER **
 ** ./src/shared/modal/ModalContainer.js
 **/